import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount } from "vue";
import useDisableScroll from "@/features/useDisableScroll";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
  isOpen: { type: Boolean, default: false },
  showClose: { type: Boolean, default: true },
  allowBackdropClick: { type: Boolean, default: true, required: false },
  classes: { type: String, default: "" },
  modalWrapperClasses: { type: String, default: "" },
  isUseDisableScroll: { type: Boolean, default: true, required: false },
},
  emits: ["close", "submit"],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




function close() {
  emit("close");
}

const keyPress = (event: KeyboardEvent) => {
  if (event && event.code === "Escape") {
    close();
  }
};
if (props.isUseDisableScroll) {
  useDisableScroll();
}

document.addEventListener("keydown", keyPress);

onBeforeUnmount(() => {
  document.removeEventListener("keydown", keyPress);
});

const __returned__ = { emit, props, close, keyPress, onBeforeUnmount, useDisableScroll }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})